import {
  dreamControllerFindOne,
  getDreamControllerFindOneQueryKey,
} from '@/api/dreams/dreams'
import { UserDream } from '@/features/dream/views/user-dream'
import { client } from '@/features/query/client'
import CoinAnimation from '@/ui/loader'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dreams/$id')({
  component: RouteComponent,
  loader: async ({ params: { id } }) => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getDreamControllerFindOneQueryKey(id),
        queryFn: () => dreamControllerFindOne(id),
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <UserDream id={id} />
}
